import { Button, Checkbox } from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import styled from "styled-components";

export const Heading = styled.div`
  font-family: "Honeywell Sans Bold";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.02em;
  color: #303030;
`;
export const Description = styled.div`
  font-family: "Honeywell Sans Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.02em;
  color: #606060;
`;

export const StyledCheckbox = withStyles({
  root: {
    color: "#303030 !important",
    marginRight: "8.5px !important",
    "& .MuiSvgIcon-root": { fontSize: 20, position: "absolute", top: "-2px" },
    "& .MuiButtonBase-root .MuiCheckbox-root .Mui-checked": {
      color: "#303030 !important",
    },
  },
})(Checkbox);

export const StyledModalButton = withStyles({
  root: {
    padding: "14px 74.5px !important",
    color: "#fff !important",
    width: "auto !important",
    height: "48px !important",
    fontFamily: "Honeywell Sans Medium !important",
    borderRadius: "4px !important",
    background: "#0071B3 !important",
    fontSize: "14px !important",
    lineHeight: "20px !important",
    textTransform: "uppercase !important",
    "&:hover ": {
      backgroundColor: "#04669f !important",
    },
  },
})(Button);

export const modalbtn = {
  fontSize: "14px !important",
  width: "170px",
  borderRadius: "4px",
};
export const useStyles = makeStyles((themes) => ({
  modalstyle: {
    background: "rgba(34, 31, 32, 0.75)",
  },
  style: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "400px",
    border: "none !important",
    background: "#FFFFFF",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
    "&:focus-visible": {
      outline: "none",
    },
  },
  mobilestyle:{
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "319px",
    border: "none !important",
    background: "#FFFFFF",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
    "&:focus-visible": {
      outline: "none",
    },
  },
  align: {
    padding: "24px",
  },
  headingspace: {
    margin: "16px 0px 8px 0px",
  },
  buttonspace: {
    marginTop: "32px",
    textAlign: "right",
  },
  iconspace: {
    width: "100%",
  },
  closewrap: {
    width: "22px",
    height: "22px",
    cursor: "pointer",
    display: "inline-block",
    position: "relative",
    float: "right",
    top: "0px",
  },
  close: { color: "#606060", fontSize: "16px" },
  warn: {
    fontSize: "32px !important",
    color: "#F15A4F",
    position: "relative",
    top: "5.5px",
  },
  warnwrap: {
    width: "48px",
    height: "48px",
    background: "#fce1df",
    textAlign: "center",
    borderRadius: "25px",
    display: "inline-block",
  },
  loaderbox:{
    textAlign:"center",
    padding:"10% 0px"
  }
}));
